import { render } from "./PledgeMaking.vue?vue&type=template&id=546f93b6&scoped=true"
import script from "./PledgeMaking.vue?vue&type=script&lang=js"
export * from "./PledgeMaking.vue?vue&type=script&lang=js"

import "./PledgeMaking.vue?vue&type=style&index=0&id=546f93b6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546f93b6"]])

export default __exports__